<template lang="html">
  <div class="helpinfo">
    <h1>Segíts nekünk!</h1>
      <transition name="fade">
        <div class="bankszamla">
          <h3>Ezen a bankszámlaszámon támogathatod védenceinket:</h3>
          <div>
            Ments Meg minket<br/>
            Próba Bank<br/>
            123456789-123456789-123456789
          </div>
        </div>
      </transition>

      <div class="ado1szazalek">
        <h3>Kérjük, add nekünk adód 1%-át!</h3>
        <h4>Adószámunk:</h4>
        <h4>123456789-1-23</h4>
      </div>

      <div class="maskeppsegits">
        <h3>Nem csak pénzzel segíthetsz!</h3>
        <p>
          Szükségünk van folyamatosan
          <ul>
            <li>száraztápra</li>
            <li>konzervekre</li>
            <li>gumikesztyűre</li>
            <li>fertőtlenítőszerekre</li>
            <li>papírtörlőre</li>
          </ul>
        </p>
      </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.maskeppsegits ul{
  list-style-type: none;
  padding: 0;
}
</style>
